import React from 'react'

import { HiExclamationTriangle } from 'react-icons/hi2'
import { twMerge } from 'tailwind-merge'

interface WarningProps {
  children: React.ReactNode
  className?: string
  icon?: React.ReactNode | false
}

export const Warning: React.FC<WarningProps> = ({
  children,
  className,
  icon,
}) => (
  <div
    className={twMerge(
      'inline-flex gap-2 p-[10px] rounded-md text-sm text-yellow-900 dark:text-yellow-200 border border-yellow-300 dark:border-yellow-800 bg-yellow-100 dark:bg-yellow-700/30',
      className,
    )}
  >
    {icon !== false &&
      (icon || (
        <HiExclamationTriangle
          size={16}
          className="mt-[3px] flex-shrink-0 text-yellow-700 dark:text-yellow-300"
        />
      ))}
    {children}
  </div>
)
